import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex mb-3 items-center",
  style: {"font-size":"28px"}
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "My Portfolio")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1  invest-farm-separator mb-8" }, null, -1)
const _hoisted_3 = { class: "mb-8 md:mb-16 md:flex" }
const _hoisted_4 = { class: "flex-1 ml-4 lg:ml-0" }
const _hoisted_5 = {
  key: 1,
  class: "apr-text text-5xl"
}
const _hoisted_6 = { class: "grid md:flex grid-cols-2 gap-x-4 md:gap-x-0 mt-8 md:mt-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-200 font-medium mb-2 text-left" }, " Pending Rewards ", -1)
const _hoisted_8 = { class: "text-xl font-medium truncate flex items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-200 font-medium mt-1 text-left" }, " MOND ", -1)
const _hoisted_10 = { class: "text-sm text-gray-200 font-medium mt-1 text-left" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-200 font-medium mb-2 text-left" }, " Average APR ", -1)
const _hoisted_12 = { class: "text-xl font-medium truncate flex items-center" }
const _hoisted_13 = { class: "text-sm text-gray-200 font-medium mt-1 text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
              key: 0,
              class: "h-10 w-40"
            }))
          : (_openBlock(), _createElementBlock("h2", _hoisted_5, " $" + _toDisplayString(_ctx.numeral(_ctx.data.totalValue).format('0,0.00')), 1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(2, (n) => {
              return _createVNode(_component_BalLoadingBlock, {
                key: n,
                class: _normalizeClass(['h-28', 'w-48', n === 1 ? 'mr-4' : ''])
              }, null, 8, ["class"])
            }), 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_BalCard, { class: "md:w-48 md:mr-4" }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.farmData.pendingWAVE) + " ", 1),
                    _hoisted_9
                  ]),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.farmData.pendingWAVEValue), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_BalCard, { class: "md:w-48" }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.farmData.apr), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.farmData.dailyEmbr) + " MOND / day ", 1)
                ]),
                _: 1
              })
            ], 64))
      ])
    ])
  ], 64))
}